/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import React from 'react'
import nl2br from 'react-nl2br'
import { ListItem } from '../../../atoms'
import { ListGroup } from '../../../molecules'
import { dateToString } from '../../../../util/DateString'

export default function ReservationLog(props) {
  if (!props.tab || props.tab !== 'log') {
    return null
  }

  if (!props.audits || props.audits.size === 0) {
    return null
  }

  return (
    <div className="reservationDetail">
      <ListGroup border="surround" className="logItems">
        {props.audits.map((audit, idx) => {
          return (
            <ListItem key={idx} className="logItem">
              <div className="row">
                <div className="col-4">
                  <strong>{audit.column_name}</strong>
                </div>
                <div className="col-4">{dateToString(audit.updated_at)}</div>
                <div className="col-4">{audit.username}</div>
              </div>
              <div className="row">
                <div className="col-6 logItem__Value logItem__Value--old">
                  <span className="logItem__Value">{nl2br(audit.old_value)}</span>
                </div>
                <div className="col-6 logItem__Value logItem__Value--new">
                  <span className="logItem__Value">{nl2br(audit.new_value)}</span>
                </div>
              </div>
            </ListItem>
          )
        })}
      </ListGroup>
    </div>
  )
}
